var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-ico",
    transform: "translate(-0.082 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_745",
    "data-name": "Ellipse 745",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(0.082 0)",
    fill: "#f0f4f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(22.547 23.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5080",
    "data-name": "Group 5080",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M37.177,29.436a13.241,13.241,0,0,0-24.534-4.4,7.585,7.585,0,0,0-1.391-.132A7.257,7.257,0,0,0,4,32.152a7.922,7.922,0,0,0,.15,1.5A10.085,10.085,0,0,0,0,41.787a10.782,10.782,0,0,0,2.735,7.135,9.763,9.763,0,0,0,6.768,3.4h8.159a1.269,1.269,0,0,0,0-2.538H9.616c-3.845-.235-7.078-3.892-7.078-8.009A7.534,7.534,0,0,1,6.27,35.292a1.279,1.279,0,0,0,.555-1.542,4.6,4.6,0,0,1-.282-1.617,4.718,4.718,0,0,1,4.709-4.709,4.629,4.629,0,0,1,1.607.282,1.275,1.275,0,0,0,1.589-.649A10.7,10.7,0,0,1,34.78,30.582a1.268,1.268,0,0,0,1.053,1.128,9.148,9.148,0,0,1-.865,18.067H28.04a1.269,1.269,0,1,0,0,2.538h7.069a11.246,11.246,0,0,0,7.539-3.722,11.7,11.7,0,0,0-5.471-19.157Z",
    transform: "translate(0 -18.4)",
    fill: "#447df7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M173.827,194.292a1.265,1.265,0,0,0,0-1.8l-6.721-6.721a1.284,1.284,0,0,0-.893-.376,1.245,1.245,0,0,0-.893.376L158.6,192.5a1.274,1.274,0,0,0,.893,2.171,1.238,1.238,0,0,0,.893-.376l4.559-4.559v20.953a1.269,1.269,0,0,0,2.538,0V189.733l4.559,4.559A1.254,1.254,0,0,0,173.827,194.292Z",
    transform: "translate(-143.352 -169.702)",
    fill: "#447df7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b452643fe54a3bbee4be14ef769611ea.svg";
export { ForwardRef as ReactComponent };